<script>
import {XCircleIcon} from "svelte-feather-icons";
import LedIndicator from "../components/LEDIndicator.svelte";
import { getContext } from "svelte";
import GrsDevices from "./grsDevices";
import LinkLeads from "./linkLeads";

export let grs
export let replaying = false

const flight = getContext("flight")
const grsDevices = flight.getHandler(GrsDevices)
const linkLeads = flight.getHandler(LinkLeads)

function getRoamingColor(roaming) {
  switch (roaming) {
    case "qualified":
      return "green"
    case "truant":
      return "red"
    case "roaming":
      return "yellow"
    case "tracking":
      return "blue"
  }
  return "off"
}

function hide() {
  grsDevices.update(devices => {
    devices[grs.id].selected = false
    return devices
  })
}

</script>

{#if grs}
<div class='grs' class:replaying>
  <header>
    <h3>{grs.name}</h3>
    <div class='close' on:click={hide}>
      <XCircleIcon size=16 />
    </div>
  </header>
  <div class='indicators'>
    <div class='indicator'>
      <LedIndicator color={grs.controlSocket ? "green" : "red"}/><span>Control</span>
    </div>
    <div class='indicator'>
      <LedIndicator color={grs.userSocket ? "green" : "red"}/><span>User</span>
    </div>
    <div class='indicator'>
      <LedIndicator color={getRoamingColor(grs.roamingState)}/><span>Roaming {grs.roamingState ?? 'Unknown'}</span>
    </div>
    <div class='info'>
      rssi {grs.lastStatus?.local.radio[0].avgRSSI ?? ''}
    </div>
    <div class="info">
      latency {grs.latency ?? ''} ms
    </div>
    {#if $linkLeads[grs.linkId] === grs.id}
      <div class="info lead">
        LEAD
      </div>
    {/if}
  </div>
</div>
{/if}

<style>
  .grs.replaying {
		background-color: rgb(88 70 37);

  }
  .grs {
    /* margin-bottom: 8px; */
    border-bottom: 1px solid rgb(73,73,73);
    padding: 8px;
  }

  header {
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:8px;
  }

  header h3 {
    margin:0;
    padding:0;
    font-size:12pt;
  } 

  .indicators {
    display:grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 4px;
  }

  .indicators .indicator {
    grid-row:1;
    display:grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto;
    align-items: center;
    gap:4px;
  }

  .info {
    white-space: nowrap;
  }
  .lead {
    background: rgb(91, 138, 167);
    border-radius: 8px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>